import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.53 13.47a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM11 16l-.53.53a.75.75 0 0 0 1.06 0L11 16Zm4.53-3.47a.75.75 0 1 0-1.06-1.06l1.06 1.06ZM18.25 7v12h1.5V7h-1.5ZM17 20.25H7v1.5h10v-1.5ZM5.75 19V7h-1.5v12h1.5ZM7 5.75h2v-1.5H7v1.5Zm8 0h2v-1.5h-2v1.5Zm-8 14.5c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 7 21.75v-1.5ZM18.25 19c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 19.75 19h-1.5Zm1.5-12A2.75 2.75 0 0 0 17 4.25v1.5c.69 0 1.25.56 1.25 1.25h1.5Zm-14 0c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 4.25 7h1.5Zm2.72 7.53 2 2 1.06-1.06-2-2-1.06 1.06Zm3.06 2 4-4-1.06-1.06-4 4 1.06 1.06ZM11 3.75h2v-1.5h-2v1.5Zm2 2.5h-2v1.5h2v-1.5Zm-2 0c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 11 7.75v-1.5ZM14.25 5c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 15.75 5h-1.5ZM13 3.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 13 2.25v1.5Zm-2-1.5A2.75 2.75 0 0 0 8.25 5h1.5c0-.69.56-1.25 1.25-1.25v-1.5Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render };